import {
  PromiseDialogFactory,
  RenderModal,
} from '#/components/ui/tickets/components/PromiseDialogFactory';

import { Button, Group, Modal, Select, Stack, Text } from '@mantine/core';
import {
  EnrollmentSummary,
  PAY_INTERVAL_LABEL,
  PayIntervalValue,
} from '../model';
import { TICKET_TYPE_CONFIG } from '../../config';
import { useEffect, useState } from 'react';

type SendResultModalData = { payInterval: EnrollmentSummary['payInterval'] };
type SendResultModalProps = {
  email: EnrollmentSummary['email'];
  type: EnrollmentSummary['type'];
};

type TSendResultModal = RenderModal<SendResultModalData, SendResultModalProps>;

const PAY_INTERVAL_VALUES: PayIntervalValue[] = [
  'WEEKLY',
  'SEMI_MONTHLY',
  'MONTHLY',
];

const PAY_INTERVAL_OPTIONS = PAY_INTERVAL_VALUES.map((value) => ({
  value,
  label: PAY_INTERVAL_LABEL[value],
  disabled: value === 'MONTHLY',
}));

const EditIntervalModal: TSendResultModal = ({
  onCancel,
  onSubmit,
  isOpen,
  email,
  type,
  input,
}) => {
  const typeName = TICKET_TYPE_CONFIG[type]?.name;
  const [select, setSelect] = useState(
    input?.payInterval ?? PAY_INTERVAL_OPTIONS[0].value,
  );

  useEffect(() => {
    if (input?.payInterval) {
      setSelect(input?.payInterval);
    }
  }, [input]);

  return (
    <Modal
      onClose={() => onCancel?.()}
      opened={isOpen}
      withCloseButton={false}
      title="編輯查繳週期"
      centered
      size="lg"
    >
      <Stack gap={0}>
        <Text c="dimmed">{`${email}．${typeName}`}</Text>
        <Select
          label="查繳週期"
          placeholder="Pick value"
          data={PAY_INTERVAL_OPTIONS}
          defaultValue={select}
          value={select}
          onChange={(value) => {
            if (!value) return;
            setSelect(value);
          }}
        />
      </Stack>
      <Group mt="xl" justify="flex-end">
        <Button variant="outline" onClick={() => onCancel?.()}>
          關閉
        </Button>
        <Button onClick={() => onSubmit?.({ payInterval: select })}>
          儲存
        </Button>
      </Group>
    </Modal>
  );
};

const {
  useModal: usePromiseEditIntervalModal,
  Modal: PromiseEditIntervalModal,
} = PromiseDialogFactory(EditIntervalModal);

export { PromiseEditIntervalModal, usePromiseEditIntervalModal };
